import React from 'react';

const Loader = props => {
    return (
        <span className="loader-container">
            <span className="loader-icon"></span>
        </span>
    );
};

export default Loader;
